import { FC } from 'react';
import { TextProps } from './types';

const PrimaryParagraph: FC<TextProps> = (props) => {

	let fontSizeClass = 'pop-text-xs'; // default
  if (props.fontSize === 'verySmall') {
    fontSizeClass = 'pop-text-xxs';
  } else if (props.fontSize === 'medium') {
    fontSizeClass = 'pop-text-sm';
  } else if (props.fontSize === 'large') {
    fontSizeClass = 'pop-text-lg';
  }

	return <p className={`${fontSizeClass} ${props.className} pop-text-popsizePrimary50`}>{props.children}</p>;
};

export default PrimaryParagraph;
